import { createTheme } from "@mui/material/styles";

export const customColors = {
  background: "#FFFFFF",
  foreground: "#000000",
  cyan: "#2F72A8",
  green: "#00b050",
  red: "#d20000",
};

export const theme = createTheme({
  palette: {
    background: {
      default: customColors.background,
    },
    primary: {
      main: customColors.background,
    },
    text: {
      primary: customColors.foreground,
    },
    warning: {
      main: customColors.red,
    },
    success: {
      main: customColors.green,
    },
  },
  typography: {
    fontFamily: "'Figtree', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: customColors.background,
          color: customColors.foreground,
        },
      },
    },
  },
});
